var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4001 0.600098H2.6001C1.4961 0.600098 0.600098 1.4961 0.600098 2.6001V15.4001C0.600098 16.5041 1.4961 17.4001 2.6001 17.4001H15.4001C16.5041 17.4001 17.4001 16.5041 17.4001 15.4001V2.6001C17.4001 1.4961 16.5041 0.600098 15.4001 0.600098ZM5.8001 7.0001V14.6001H3.4001V7.0001H5.8001ZM3.4001 4.7881C3.4001 4.2281 3.8801 3.8001 4.6001 3.8001C5.3201 3.8001 5.7721 4.2281 5.8001 4.7881C5.8001 5.3481 5.3521 5.8001 4.6001 5.8001C3.8801 5.8001 3.4001 5.3481 3.4001 4.7881ZM14.6001 14.6001H12.2001C12.2001 14.6001 12.2001 10.8961 12.2001 10.6001C12.2001 9.8001 11.8001 9.0001 10.8001 8.9841H10.7681C9.8001 8.9841 9.4001 9.8081 9.4001 10.6001C9.4001 10.9641 9.4001 14.6001 9.4001 14.6001H7.0001V7.0001H9.4001V8.0241C9.4001 8.0241 10.1721 7.0001 11.7241 7.0001C13.3121 7.0001 14.6001 8.0921 14.6001 10.3041V14.6001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.33122110.svg";
export { ForwardRef as ReactComponent };